<template lang="pug">
    .login
        //- .title.text-center
        //-     h3(v-if="login")
        //-         |Login
        //-     h3(v-if="!login")
        //-         | Registro
        //- .form-group
        //-     label.form-label
        //-         | Nombre de usuario
        //-     input.form-input(v-model="name")
        //- .form-group
        //-     label.form-label
        //-         | Contraseña
        //-     input.form-input(v-model="password",type="password")
        //- .form-group(v-if="!login")
        //-     label.form-label
        //-         | Wallet
        //-     input.form-input(v-model="wallet")
        .title.text-center.m-2
            h3
                | Login
        .form-group
            input.btn.btn-primary(type="button", value="Login", v-on:click="Login")
            
        //- .text-center
        //-     a.text-bold(v-if="login", v-on:click.prevent="login = false", style="cursor: pointer")
        //-         | Registrarse
        //-     a.text-bold(v-if="!login", v-on:click.prevent="login = true", style="cursor: pointer")
        //-         | ¿Ya tienes cuenta?
</template>

<script>
import gun from "../managers/gun";
// import Swal from 'sweetalert2'
require("web3-eth-accounts");
export default {
  data() {
    return {
      name: sessionStorage.getItem("alias"),
      password: "",
      wallet: "",
      login: true,
      secret: "healthchain"
    };
  },
  methods: {
    async Login() {
      var accounts = await window.web3.eth.getAccounts();
      window.web3.eth.personal
        .sign(this.secret, accounts[0], this.secret)
        .then(async result => {
          
          console.log("login!");
          gun
            .user()
            .create(accounts[0], result,() => {
              gun.user().auth(accounts[0], result, () => {
        
                gun
                  .user()
                  .get("profile")
                  .get("wallet")
                  .put(accounts[0]);
                  console.log("update wallet")
                           this.$nextTick(() => {
                               this.$emit("logged")
                            this.$forceUpdate()
                        })
              });
            });
          // }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  padding-bottom: 15px;
  padding-top: 15px;
  input {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
  }
  .form-group {
      margin-top: 2em;
  }
}
</style>